import type { ModelAssignButtonProps } from "./model-assign-button.type";

import { useTranslation } from "react-i18next";

import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";

export const useModelAssignButton = ({
  item,
  form,
  onClick,
  ...buttonProps
}: ModelAssignButtonProps) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canAssignItem } = useAuthorization();

  const openAssignForm = () => {
    openSidePanel({
      title: t("global:assignForm.title"),
      component: form,
    });
  };

  const onButtonClick: ModelAssignButtonProps["onClick"] = (e) => {
    openAssignForm();
    onClick?.(e);
  };

  return {
    hideButton: !canAssignItem(item),
    onClick: onButtonClick,
    ...buttonProps,
  };
};
